import { render, staticRenderFns } from "./Newsle.vue?vue&type=template&id=9b696938&scoped=true"
import script from "./Newsle.vue?vue&type=script&lang=js"
export * from "./Newsle.vue?vue&type=script&lang=js"
import style0 from "./Newsle.vue?vue&type=style&index=0&id=9b696938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b696938",
  null
  
)

export default component.exports